import React from 'react'
import { styled } from 'linaria/react'
import PackageProductCard from '../../Core/Cards/PackageProductCard'
import { theme } from '../../Theme'
import t from '@jetshop/intl'

const PackageProductsWrapper = styled.div`
   background-color: #f0f0f0;
   border: 1px solid #dee1e9;
   border-radius: 4px;
   padding: 0 0.75rem 0 0.75rem;
   ${theme.below.md} {
      padding: 0 0.5rem 0 0.5rem;
   }

   .product-package-name {
      font-family: var(--font-industry);
      font-weight: 700;
      font-size: calc(0.7vw + 0.9rem);
      word-wrap: break-word;
   }
`

const PackageProductContainer = styled.div`
   background-color: #fff;
   border-radius: 0.5rem;

   .product-image {
      width: 100%;
   }
`

const ProductPackageProducts = ({ packageProducts, className }) => {
   if (!Array.isArray(packageProducts) && !packageProducts?.length) {
      return <></>
   }

   return (
      <PackageProductsWrapper className={`${className}`}>
         <h2 className="product-package-name py-8">{t('products included in package')}</h2>
         {packageProducts?.map((packageProduct, i) => {
            const formattedPackageProduct = {
               ...packageProduct?.product,
               price: packageProduct?.price,
               previousPrice: packageProduct?.previousPrice,
               stockStatus: packageProduct?.product?.variants?.values[0]?.stockStatus ?? packageProduct?.product?.stockStatus,
               isPackageItem: true
            }
            return (
               <React.Fragment key={i}>
                  <PackageProductContainer className="mb-16">
                     <PackageProductCard
                        product={formattedPackageProduct}
                     ></PackageProductCard>
                  </PackageProductContainer>
               </React.Fragment>
            )
         })}
      </PackageProductsWrapper>
   )
}

export default ProductPackageProducts
